import { render, staticRenderFns } from "./HistoryFile.vue?vue&type=template&id=fa86f120&"
import script from "./HistoryFile.vue?vue&type=script&lang=js&"
export * from "./HistoryFile.vue?vue&type=script&lang=js&"
import style0 from "./HistoryFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports